import { createSlice } from '@reduxjs/toolkit';
import LogoImage from '../../Images/Login/schoollogo.png';

const initialState = {
  logo: LogoImage,
  title: "Amalraj Matriculation & Higher Secondary School",
  darkColor: "#002a28",
  mainColor: "#004643",
  lightColor: "#99b5b3",
  textColor: "#ffffff",
  backgroundColor: "#CCDAD9",
};

const websiteSettingsSlice = createSlice({
  name: 'websiteSettings',
  initialState,
  reducers: {
    setWebsiteSettings: (state, action) => {
      state.logo = action.payload.logo;
      state.title = action.payload.title;
      state.darkColor = action.payload.darkColor;
      state.mainColor = action.payload.mainColor;
      state.lightColor = action.payload.lightColor;
      state.textColor = action.payload.textColor;
      state.backgroundColor = action.payload.backgroundColor;
    },
  },
});

export const { setWebsiteSettings } = websiteSettingsSlice.actions;
export const selectWebsiteSettings = (state) => state.websiteSettings;

export default websiteSettingsSlice.reducer;
